import React, { createContext, useEffect, useRef, useState } from "react";
import {
	OrderInner,
	OrderPageNavigationImg,
	OrderPageNavigationInner,
	OrderPageNavigationWrap,
} from "../../Order/styled/OrderStyle";
import { BookingContentName, BookingContentWrap, MyBookingTableContainer, MyBookingTableContainerAdmin } from "../../MyBooking/styled/DesStyled";
import { getListUser } from "../hook/GetListUser";
import { Table, TableBody, TableHead, TableRow } from "@material-ui/core";
import { CommonTableHeadCell } from "../../../controls/components/commonTable/CommonTable";
import UserTableBody from "./UserTableBody";
import DialogUpdateUserAdmin from "./DialogUpdateUserAdmin";
import DialogBanUser from "./DialogBanUser";
import User from "../../../../models/User";

export default function UserTable(props: { listUser: User[]; reload: () => void }) {
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);
	const [orderId, setOrderId] = useState("");
	const [banDialogOpen, setBanDialogOpen] = useState(false);
	const [banUserId, setBanUserId] = useState<string | null>(null);
	return (
		<BookingContentWrap>
			<BookingContentName>User</BookingContentName>
			<React.Fragment>
				<MyBookingTableContainerAdmin>
					<Table aria-label="simple table">
						<TableHead>
							<TableRow>
								<CommonTableHeadCell align="center">ID</CommonTableHeadCell>
								<CommonTableHeadCell align="center">Fullname</CommonTableHeadCell>
								<CommonTableHeadCell align="center">Email</CommonTableHeadCell>
								<CommonTableHeadCell align="center">Phone</CommonTableHeadCell>
								<CommonTableHeadCell align="center"> Role</CommonTableHeadCell>
								<CommonTableHeadCell align="center"> Communication</CommonTableHeadCell>

								<CommonTableHeadCell align="center"> Status</CommonTableHeadCell>
								<CommonTableHeadCell align="center"> Ban</CommonTableHeadCell>
								<CommonTableHeadCell align="center"> Action</CommonTableHeadCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{props.listUser.map((val, index) => (
								<UserTableBody
									key={index}
									val={val}
									reload={props.reload}
									setIsDialogLoginOpen={setIsDialogLoginOpen}
									setOrderId={setOrderId}
									onOpenBan={(id) => {
										setBanUserId(id);
										setBanDialogOpen(true);
									}}
								/>
							))}
						</TableBody>
					</Table>
				</MyBookingTableContainerAdmin>
				<DialogUpdateUserAdmin
					openDialog={isDialogLoginOpen}
					setOpenDialog={setIsDialogLoginOpen}
					UserId={orderId}
					reload={props.reload}
				/>
				<DialogBanUser
					openDialog={banDialogOpen}
					setOpenDialog={setBanDialogOpen}
					userId={banUserId}
					reload={props.reload}
				/>
			</React.Fragment>
		</BookingContentWrap>
	);
}
